var render, staticRenderFns
import script from "./BaseAnimation.vue?vue&type=script&lang=js&"
export * from "./BaseAnimation.vue?vue&type=script&lang=js&"
import style0 from "./BaseAnimation.vue?vue&type=style&index=0&id=53d0aa98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0aa98",
  null
  
)

export default component.exports